import { GraphQLError } from "graphql"

import { CommerceService } from "@/services/commerce"

import { isAdmNumberOfUser } from "./admPermissionsHelper"

export const checkRegionalLeadAccessRightsToAdmNumber = async ({ user, admNumber }) => {
  if (!isRegionalLeadOfAdmNumber({ user, admNumber }) && !isAdmNumberOfUser({ user, admNumber })) {
    throw new GraphQLError("You are not authorized to perform this operation.", {
      extensions: {
        code: "FORBIDDEN",
      },
    })
  }
}

const isRegionalLeadOfAdmNumber = async ({ user, admNumber }) => {
  let matches = []

  // If regional lead has a regional lead, check if ADM is assigned to one of them
  for (const employeeNumber of user.regionalLeadNumbers) {
    const results = await getAdmByAdmNumberAndRegionalLead({
      admNumber,
      regionalLeadNumber: employeeNumber,
    })
    matches.push(results)
  }

  const results = await getAdmByAdmNumberAndRegionalLead({
    admNumber,
    regionalLeadNumber: user.employeeNumber,
  })
  matches.push(results)

  return matches.length > 0
}

const getAdmByAdmNumberAndRegionalLead = async ({ admNumber, regionalLeadNumber }) => {
  const commerceApi = CommerceService.api()
  const response = await commerceApi
    .customers()
    .get({
      queryArgs: {
        where: `custom(fields(regionalLeadNumbers contains any ("${regionalLeadNumber}") and admNumbers contains any ("${admNumber}") )) `,
      },
    })
    .execute()
  return response?.body?.results
}
